import styled from 'styled-components'
import { margin, MarginProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

export const Line = styled.div<MarginProps>`
  width: 20px;
  height: 1px;
  background-color: ${themeGet('colors.border.slight')};

  ${margin}
`
